module.exports = __webpack_public_path__ + "static/favicon-df88d330f197f319c320fc3321218141.ico";